<template>
  <!-- <v-card class="mx-auto col-8 my-12 text-center" max-width="600"> -->
  <b-row class="text-center pt-3 pb-6">
    <b-col>
      <!-- <v-card-title>Скачай приложение</v-card-title> -->
      <!-- <v-card-text> -->
      <p class="mobile-app-title" tabindex="0">{{ $t("mobileAppTitle") }}</p>
      <!-- <br /> -->
      <p class="mobile-app-description" tabindex="0">
        {{ $t("mobileAppDescription") }}
      </p>
      <!-- </v-card-text> -->

      <!-- <v-divider class="mx-4"></v-divider> -->

      <!-- <v-card-actions> -->
      <b-row class="justify-content-center mb-3">
        <!-- <div class="text-center"> -->
        <b-col class="text-center text-md-right">
          <!-- <b-row justify="space-around"> -->
          <!-- <div class="text-center"> -->
          <!-- <b-col class="col-5"> -->
          <!-- <br /> -->
          <b-button
            class="mobile-app-button"
            variant="transparent"
            href="https://itunes.apple.com/by/app/buzzpoint/id1426274827?mt=8"
            target="_blank"
            :aria-label="$t('appStore')"
          >
            <img
              src="./../assets/appStore2.svg"
              width="150"
              alt="AppStore link"
            />
            <!-- <v-img src="./../assets/appStore.png" aspect-ratio="1" class="grey lighten-2" max-width="500"></v-img> -->
            <!-- 
                    <img src="./../assets/appStore.svg" width="250"></img> -->
          </b-button>
        </b-col>
        <!-- <b-col class="col-5"> -->
        <b-col class="text-center text-md-left">
          <b-button
            class="mobile-app-button"
            variant="transparent"
            href="https://play.google.com/store/apps/details?id=by.sibel.buzzpoint.buzzer"
            target="_blank"
            :aria-label="$t('playMarket')"
          >
            <img
              src="./../assets/googlePlay2.svg"
              width="150"
              alt="Google Play market link"
            />
          </b-button>
        </b-col>
        <!-- </div> -->
      </b-row>
    </b-col>
    <!-- </div> -->
  </b-row>
  <!-- </v-card-actions> -->
  <!-- <br /> -->
  <!-- </b-col> -->
  <!-- </b-row> -->
  <!-- </v-card> -->
</template>

<script>
export default {};
</script>

<style scoped>
.mobile-app-title {
  font-size: 1.5rem;
}
.mobile-app-description {
  font-size: 1rem;
  margin: 0 5%;
}

.mobile-app-button span {
  margin: auto;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
@media screen and (min-width: 668px) {
  .mobile-app-title {
    font-size: 1.5rem;
  }
  .mobile-app-description {
    font-size: 1.2rem;
  }

  .mobile-app-button span {
    margin: inherit;
  }
}
</style>
